module.exports = __webpack_public_path__ + "img/telegram-icon.81218941.png";